import React from 'react';
import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { scrollBarStyle } from '../../utils/layoutConfig';
import { useDispatch } from 'react-redux';
import { selectComponents } from '../../redux/componentsTabSlice';
import { selectedIndex } from '../../redux/componentsTabSlice';
import { useSelector } from 'react-redux';
import SelectDraggableComponent from './SelectDraggableComponent';
import theme from '../../utils/ChakraTheme';
import { ChakraProvider } from '@chakra-ui/react';

const boxShadowStyle = { boxShadow: 'inset 0px 2px 4px rgba(0, 0, 0, 0.06);' };
const newScrollBarStyle = Object.assign({ ...scrollBarStyle }, boxShadowStyle);

function handleTabClick({ setRecentCommitsIsOpen, components, setTabIndex, e, tabIndex, dispatch }) {
	const index = e.target.getAttribute('index');
	setRecentCommitsIsOpen(false);

	if (index == tabIndex) {
		setTabIndex(-1);
		dispatch(selectComponents({ index: -1, components: false }));
	} else {
		console.log(index);
		setTabIndex(index);
		dispatch(selectComponents({ index, components }));
	}
}

const ComponentTabsWM = ({ setRecentCommitsIsOpen, setTabIndex, filteredComponentList, componentList }) => {
	const dispatch = useDispatch();
	const tabIndex = useSelector(selectedIndex);

	return (
		<ChakraProvider theme={theme} resetCSS={false}>
			<Tabs
				onChange={(e) => {
					setTabIndex(-1);
				}}
				color={'blue.600'}
				pr={3}
			>
				<TabList borderWidth={0}>
					{((filteredComponentList.length && filteredComponentList) || componentList).map((componentType, ind) => (
						<Tab
							key={ind}
							py={2}
							px={3}
							_selected={{
								color: 'blue.600 !important',
								borderColor: 'yellow.400',
								borderBottomWidth: '4px',
							}}
							fontSize={'xs'}
							_active={{ borderBottomColor: 'yellow.400' }}
						>
							{componentType.title}
						</Tab>
					))}
				</TabList>
				<TabPanels pt={2}>
					{((filteredComponentList.length && filteredComponentList) || componentList).map((componentType, ind) => (
						<TabPanel p={2} key={ind} overflow={'auto'} sx={newScrollBarStyle}>
							<Tabs
								index={Number(tabIndex)}
								variant="unstyled"
								orientation={'vertical'}
								flexDir={'column'}
								isFitted
								isLazy={true}
							>
								<TabList borderWidth={0}>
									<SelectDraggableComponent components={componentType.components} ind={ind} />
								</TabList>
							</Tabs>
						</TabPanel>
					))}
				</TabPanels>
			</Tabs>
		</ChakraProvider>
	);
};
const ComponentTabs = React.memo(ComponentTabsWM);
export default ComponentTabs;
